import { render, staticRenderFns } from "./CommentSidebar.vue?vue&type=template&id=cd840da0"
import script from "./CommentSidebar.vue?vue&type=script&lang=js"
export * from "./CommentSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports